<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Previous Remuneration YTD (TP3)"
      text="Update Previous Remuneration YTD"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-menu
              v-model="previousCompanyResignedDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="recordedDateDisplay"
                  v-validate="'required'"
                  :error-messages="errors.collect('recordedDateDisplay')"
                  data-vv-name="recordedDateDisplay"  
                  data-vv-as="resigned date"    
                  label="Previous Company Resigned Date"
                  outlined
                  class="label-position"
                  readonly
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localPreviousRemuneration.recorded_date"
                no-title
                @input="previousCompanyResignedDateMenu = false"
              />
            </v-menu>
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localPreviousRemuneration.accumulated_remuneration"
              v-money="money"
              label="Accumulated Remuneration"
              prefix="RM"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localPreviousRemuneration.accumulated_pcb"
              v-money="money"
              label="Accumulated PCB"
              prefix="RM"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localPreviousRemuneration.accumulated_epf"
              v-money="money"
              label="Accumulated EPF"
              prefix="RM"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localPreviousRemuneration.accumulated_socso"
              v-money="money"
              label="Accumulated SOCSO"
              prefix="RM"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localPreviousRemuneration.accumulated_eis"
              v-money="money"
              label="Accumulated EIS"
              prefix="RM"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localPreviousRemuneration.accumulated_zakat"
              v-money="money"
              label="Amount of Zakat"
              prefix="RM"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localPreviousRemuneration.accumulated_levy_exemption"
              v-money="money"
              label="Levy Exemption for Umrah Travel"
              prefix="RM"
              outlined
            />
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions v-if="dialog">
        <v-spacer />
        <v-btn
          text
          :disabled="progressing"
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"    
          class="white--text px-10"    
          :loading="progressing"
          @click="submitForm"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      previousRemuneration: {
        type: Object,
        required: true,
      },
    },

    data () {
      return {
        dialog: false,
        progressing: false,
        localPreviousRemuneration: null,
        previousCompanyResignedDateMenu: false,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },

    computed: {
      recordedDateDisplay () {
        return (this.localPreviousRemuneration || {}).recorded_date ? this.$moment((this.localPreviousRemuneration || {}).recorded_date, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },
    watch: {
      dialog: function (val) {
        if (!val) return this.$resetData()

        this.localPreviousRemuneration = { ...this.previousRemuneration }
      },
    },

    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.progressing = true

            this.$api.hrisPreviousRemunerations().update(this.previousRemuneration.id, this.prepareFormData())
              .then(res => {
                this.$emit('updated')
                this.progressing = false
                this.dialog = false
              })
          })
      },
      prepareFormData () {
        return {
          recorded_date: this.localPreviousRemuneration.recorded_date,
          accumulated_remuneration: this.localPreviousRemuneration.accumulated_remuneration.toString().replaceAll(',', ''),
          accumulated_epf: this.localPreviousRemuneration.accumulated_epf.toString().replaceAll(',', ''),
          accumulated_pcb: this.localPreviousRemuneration.accumulated_pcb.toString().replaceAll(',', ''),
          accumulated_socso: this.localPreviousRemuneration.accumulated_socso.toString().replaceAll(',', ''),
          accumulated_zakat: this.localPreviousRemuneration.accumulated_zakat.toString().replaceAll(',', ''),
          accumulated_levy_exemption: this.localPreviousRemuneration.accumulated_levy_exemption.toString().replaceAll(',', ''),
          accumulated_eis: this.localPreviousRemuneration.accumulated_eis.toString().replaceAll(',', ''),
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
